/*
 * @Author: bbqin
 * @Date: 2022-07-07 16:14:56
 * @LastEditTime: 2022-07-29 15:20:37
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\log.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

const color = name => {
    return function (str, ...params) {
        if (typeof console !== 'undefined') {
            console.log(`%c %c ${str}`, `background: ${name}`, `color:${name}`, ...params);
        }
    };
};

export const warning = function (condition, message, ...args) {
    if (!condition) {
        if (typeof console !== 'undefined') {
            color('red')(message);
            console.error(message, ...args);
        }
    }
};

export const error = function (condition, message, ...args) {
    if (!condition) {
        if (typeof console !== 'undefined') {
            color('red')(message);
            console.error(message, ...args);
        }
    }
};

export const red = color('red');

export const orange = color('orange');

export const blue = color('blue');

export const green = color('green');

export const grey = color('grey');